import TableCell from '@mui/material/TableCell'
import TooltipCustom from 'components/atoms/tooltipCustom'

import type { Campaign } from '../../types'

import { SubInfo } from '../SubInfo/SubInfo'

export function NameCell({
	getDataClientWidth,
	...campaign
}: Campaign & {
	getDataClientWidth: (name: string) => boolean
}) {
	const isSomethingRow = getDataClientWidth(campaign.name)

	return (
		<TableCell
			className='name semi-bold title-company'
			scope='row'
			style={{ width: '28%' }}
		>
			<div className='name-text-container'>
				<div className='wrapper-performed-bar'>
					<TooltipCustom
						arrow={true}
						title={isSomethingRow ? campaign.name : ''}
					>
						<p className={isSomethingRow ? 'ellipsis' : 'left-list-text'}>
							{campaign.name}
						</p>
					</TooltipCustom>

					<SubInfo {...campaign} />
				</div>
			</div>
		</TableCell>
	)
}
